import { NavPositionContext } from "contexts";
import React, { useContext } from "react";
import Container from "react-bootstrap/Container";
import logo from "assets/images/hopeedulogo.png";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link, useLocation } from "react-router-dom";
import { URLPaths } from "utilities";
import { BsFillArrowRightCircleFill } from "react-icons/bs";
import "./Navigation.scss";

/** Generating the MapNavigation bar for the picture wall */
/** This file can also be added with further authentification for administrative privilege */
export const pictureWallNavBarHeight = "6rem";

export function PictureWallNav(): JSX.Element {
  const { navPosition } = useContext(NavPositionContext);

  return (
      <Navbar
        bg="light"
        className="original-navbar"
        fixed={navPosition}
        style={{ height: pictureWallNavBarHeight }}
      >
        <EdImage />
        <Container>
          <h1 className="navbar-title">Current Student Teachers and Faculty</h1>
          <Nav />
        </Container>
        {/* <RNavLinkArrow path={URLPaths.edDepInfo}> </RNavLinkArrow> */}

        <ActionNavLink
          path={URLPaths.map}
          text="Touch To View Education Opportunities In Michigan"
        />
        <ActionNavLink path={URLPaths.edDepInfo} text="Touch To See Ed Department Updates" />
      </Navbar>
  );
}

type NavLinkProps = {
  path: string;
  children: React.ReactNode;
};

// function RNavLinkArrow({ path, children }: NavLinkProps): JSX.Element {
//   const { pathname } = useLocation();
//   return (
//     <Link to={path} id="right-nav-arrow">
//       {children}
//       <button className={`nav-link-arrow-right  ${pathname === path ? "active" : ""}`}>
//         <BsFillArrowRightCircleFill />
//       </button>
//       <p className="nextText-short">Info</p>
//     </Link>
//   );
// }

function EdImage(): JSX.Element {
  return <img className="edlogo" id="logo" alt="edu" src={logo} />;
}

type ActionNavLinkProps = {
  path: string;
  text: string;
};

function ActionNavLink({ path, text }: ActionNavLinkProps): JSX.Element {
  const { pathname } = useLocation();
  return (
    <Link to={path} className={`action-nav-link ${pathname === path ? "active" : ""}`}>
      <button className="action-button">{text}</button>
    </Link>
  );
}
